import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Auditor, AuditorCompetency, AuditorEvalStandard, AuditorEvalTest, AuditorEvalTestAnswer, AuditorEvaluation, AuditorIndustryCompetency, AuditorPerformanceCriterium, AuditorPerformanceLineItem, AuditorPerformanceScorecard, AuditorRecord, AuditorStandardRate, Person, TestQuestion, UserNote, UserProfile, webpages_Membership, webpages_Role } from 'app/shared/models/domain/data.model';
import { PageRequest } from 'app/shared/models/request/page-request.model';
import { PageResponse } from '@iapmoit/library.angular.core';
import { environment } from 'environments/environment';
import { forkJoin, Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { AuditorDetailsView } from './auditors-details/auditors-detail.types';
import { AuditorCompetencyView } from './models/auditor-competency-view.model';
import { AuditorLoginAccessView } from './models/auditor-login-access-view.model';
import { AuditorRecordCompetencyView } from './models/auditor-record-competency-view.model';
import { AuditorRecordEvaluationView } from './models/auditor-record-evaluation-view.model';
import { AuditorRecordMiscellaneousView } from './models/auditor-record-miscellaneous-view.model';
import { AuditorRecordPerformanceView } from './models/auditor-record-performance-view.model';
import { AuditorRecordTrainingView } from './models/auditor-record-training-view.model';
import { AuditorRecordWitnessView } from './models/auditor-record-witness-view.model';
import { AuditorsView } from './models/auditors-view.model';
import { AuditorIndustryCodeCompetencyView } from './models/auditor-industry-code-competency-view.model';
import { AuditorUnavaibilityView } from './models/auditor-unavaibility-view.model';
import { DatePipe } from '@angular/common';
import { AuditorsToStandardView } from 'app/modules/audits/models/auditors-to-standard-view.model';
import { AuditorPerformanceScorecardView } from 'app/modules/auditor/auditor.types';
import { AuditorPerformanceScorecardDetailsView } from './auditors-details/auditors-performance-scorecard-detail.types';
import { AuditorCompetencySummary, AuditorStandard } from 'app/shared/models/domain/data-extra.model';

@Injectable({
  providedIn: 'root'
})
export class AdminAuditorService {
  baseUrl = environment.apiBaseUrl;

  constructor(private _httpClient: HttpClient,
    private _datePipe: DatePipe) { }

  private sortCompetencyMap: any = {
    standardId: 'standardId',
    industryCodeId: 'industryCodeId',
    auditorLevelId: 'auditorLevelId',
    approvalDate: 'approvalDate'
  };

  private sortCompetencyIndustryCodeMap: any = {
    standardId: 'standardId',
    industryCodeId: 'industryCodeId',
    id: 'id',
    created: 'created'
  };

  private sortTrainingRecordMap: any = {
    trainingDate: 'trainingDate'
  };

  private sortCompetencyRecordMap: any = {
    competencyDate: 'competencyDate'
  };

  private sortEvaluationRecordMap: any = {
    evaluationDate: 'evaluationDate'
  };

  private sortMiscellaneousRecordMap: any = {
    recordDate: 'recordDate'
  };

  private sortPerformanceRecordMap: any = {
    recordDate: 'recordDate'
  };

  private sortWitnessRecordMap: any = {
    recordDate: 'recordDate'
  };

  getParams(request, params): any {
    params['itemsPerPage'] = request.itemsPerPage?.toString();
    params['currentPage'] = request.currentPage?.toString();

    params[`sort[${request.sort}]`] = request.sortDir;

    if (request.query) {
      params['find[auditorId]'] = request.query;
    }

    if (request.query) {
      params['find[auditorId]'] = request.query;
    }

    if (request['auditAuditorList'] && request['auditAuditorList']?.length) {
      params['find[auditorId:in]'] = request['auditAuditorList'].join();
    }

    if (request.auditorIds) {
      params['find[auditorUserId]'] = request.auditorIds;
    }
    if (request.auditorIdData) {
      params['find[auditorId]'] = request.auditorIdData?.join();
    }
    if (request.auditorPerformanceScorecardId) {
      params['find[auditorPerformanceScorecardId]'] = request.auditorPerformanceScorecardId;
    }
    if (request.scorecardStatus) {
      params['find[status]'] = request.scorecardStatus;
    }
    if (request.id) {
      params['find[id]'] = request.id;
    }
    if (request.auditorPerformanceScorecardId) {
      params['find[auditorPerformanceScorecardId]'] = request.auditorPerformanceScorecardId;
    }

    if (request.auditorStatusList) {
      params['find[AuditorStatusId]'] = request.auditorStatusList;
    }

    if (request.sponsorLocationList) {
      params['find[SponsorLocationId]'] = request.sponsorLocationList;
    }

    if (request.industryCodeList) {
      params['orLike[IndustryScopes]'] = request.industryCodeList;
    }
    if (request.auditorIndustryCodeList) {
      params['orLike[IndustryScopes]'] = request.auditorIndustryCodeList;
    }

    if (request.countryList) {
      params['find[CountryId]'] = request.countryList;
    }

    if (request.standardList) {
      params['orlike[StandardIds]'] = request.standardList;
    }
    if (request.auditorStandardNameList) {
      params['orlike[StandardIds]'] = request.auditorStandardNameList;
    }
    if (request.standardNameList) {
      params['orlike[Standards]'] = request.standardNameList;
    }
    if (request.auditAuditorList && request.auditAuditorList !== '' && request.auditAuditorList?.length) {
      params['find[auditorId:in]'] = request.auditAuditorList?.join();
    }

    if (request.searchParam) {
      params['orlike[FullName]'] = request.searchParam;
    }

    if (request['status:ge']) {
      params['find[status:ge]'] = request['status:ge'];
    }
    if (request.startDate) {
      params['find[startDate:gte]'] = this._datePipe.transform(request.startDate, 'yyyy-MM-dd');
      params['find[startDate:lte]'] = this._datePipe.transform(request.endDate, 'yyyy-MM-dd');
    }

    if (request.auditorId) {
      params['find[auditorId]'] = request.auditorId;
    }

    return params;
  }

  attachAccountToAuditor(profile: UserProfile, auditor: AuditorDetailsView): Observable<any> {
    if (profile && profile.email) {

      let profileTask: Observable<UserProfile> = null;

      //  if profile and userId already exists: just look it up
      if (profile.userId > 0) {
        profileTask = this._httpClient.get(`${this.baseUrl}api/data/user-profile/${profile.userId}`).pipe(map((data: PageResponse<UserProfile>) => data.item));
      } else {
        //  if profile does not yet exist we need to create it
        profileTask = forkJoin([
          //  get Auditor role so we can attach it by id
          this._httpClient.get(`${this.baseUrl}api/data/admin/roles?find[RoleName]=Auditor`).pipe(map((data: PageResponse<webpages_Role>) => data.items[0]))
          //  insert the new row in UserProfiles
          , this._httpClient.post(`${this.baseUrl}api/data/user-profile`, profile).pipe(map((data: PageResponse<UserProfile>) => data.item))
        ]).pipe(
          switchMap(([role, newProfile]: [webpages_Role, UserProfile]) => {

            return forkJoin([
              //  create membership to save password etc.
              this._httpClient.post(`${this.baseUrl}api/data/member`, { userId: newProfile.userId }).pipe(map((data: PageResponse<webpages_Membership>) => { return data.item; }))
              //  attach the role
              , this._httpClient.post(`${this.baseUrl}api/data/admin/user-roles/${newProfile.userId}/${role.roleId}`, {})
            ]).pipe(switchMap((data) => {
              //  finally return the user we just created
              return this._httpClient.get(`${this.baseUrl}api/data/user-profile/${newProfile.userId}`).pipe(map((data: PageResponse<UserProfile>) => data.item));
            }));
          }));
      }

      return profileTask
        .pipe(
          switchMap((profileData: UserProfile) => {
            //  now we have our user - attach to the Auditor
            const payload: Auditor = auditor.auditor;

            payload.userId = profileData.userId;

            return this.saveAuditor(payload.auditorId, payload);
          })
        );
    }
  }

  saveAuditor(auditorId: number, auditor: Auditor) {
    if (auditorId) {
      return this._httpClient.put<PageResponse<Auditor>>(`${this.baseUrl}api/data/auditor/${auditorId}`, auditor);
    } else {
      return this._httpClient.post<PageResponse<Auditor>>(`${this.baseUrl}api/data/auditor`, auditor);
    }
  }
  updateExpenseReport(id, payload) {
    if (id) {
      return this._httpClient.put<PageResponse<Auditor>>(`${this.baseUrl}api/admin/expense-reports/${id}`, payload);
    } else {
      return this._httpClient.post<PageResponse<Auditor>>(`${this.baseUrl}api/admin/expense-reports`, payload);
    }
  }

  saveAuditorEval(auditorEvalId, auditorEval: AuditorEvaluation): any {
    if (auditorEvalId) {
      return this._httpClient.put<PageResponse<Auditor>>(`${this.baseUrl}api/admin/auditor-evaluations/${auditorEvalId}`, auditorEval);
    } else {
      return this._httpClient.post<PageResponse<Auditor>>(`${this.baseUrl}api/admin/auditor-evaluations`, auditorEval);
    }
  }

  saveAuditorEvalTests(auditorEvalTestId, auditorEvalTest: AuditorEvalTest): any {
    if (auditorEvalTestId) {
      return this._httpClient.put<PageResponse<Auditor>>(`${this.baseUrl}api/admin/auditor-eval-tests/${auditorEvalTestId}`, auditorEvalTest);
    } else {
      return this._httpClient.post<PageResponse<Auditor>>(`${this.baseUrl}api/admin/auditor-eval-tests`, auditorEvalTest);
    }
  }

  saveAuditorEvalTestAnswer(auditorEvalTestAnswerId, auditorEvalTestAnswer: AuditorEvalTestAnswer): any {
    if (auditorEvalTestAnswerId) {
      return this._httpClient.put<PageResponse<Auditor>>(`${this.baseUrl}api/admin/auditor-eval-test-answers/${auditorEvalTestAnswerId}`, auditorEvalTestAnswer);
    } else {
      return this._httpClient.post<PageResponse<Auditor>>(`${this.baseUrl}api/admin/auditor-eval-test-answers`, auditorEvalTestAnswer);
    }
  }
  saveQuestion(questionId, question: TestQuestion): any {
    if (questionId) {
      return this._httpClient.put<PageResponse<Auditor>>(`${this.baseUrl}api/admin/test-questions/${questionId}`, question);
    } else {
      return this._httpClient.post<PageResponse<Auditor>>(`${this.baseUrl}api/admin/test-questions`, question);
    }
  }

  submitForReview(payload): any {
      return this._httpClient.put<PageResponse<any>>(`${this.baseUrl}api/admin/auditor-evaluations/${payload.id}`, payload);
  }

  saveAuditorEvalTestStandard(auditorEvalStandardId, auditorEvalStandard: AuditorEvalStandard): any {
    if (auditorEvalStandardId) {
      return this._httpClient.put<PageResponse<Auditor>>(`${this.baseUrl}api/admin/auditor-eval-standards/${auditorEvalStandardId}`, auditorEvalStandard);
    } else {
      return this._httpClient.post<PageResponse<Auditor>>(`${this.baseUrl}api/admin/auditor-eval-standards`, auditorEvalStandard);
    }
  }

  removeAuditorEvalTestStandard(auditorEvalStandardId): any {
      return this._httpClient.delete<PageResponse<Auditor>>(`${this.baseUrl}api/admin/auditor-eval-standards/${auditorEvalStandardId}`);
  }

  removeAuditorEvalTestCompetency(auditorEvalCompetencyId): any {
      return this._httpClient.delete<any>(`${this.baseUrl}api/data/admin/auditor-industry-competency/${auditorEvalCompetencyId}`);
  }

  getAuditorDetails(auditorId: number): Observable<AuditorDetailsView> {
    return this._httpClient.get<PageResponse<Auditor>>(`${this.baseUrl}api/data/auditor/${auditorId}`).pipe(
      switchMap((auditor: PageResponse<Auditor>) => {
        const tasks = [
          (auditor.item.personId > 0) ? this._httpClient.get<PageResponse<Person>>(`${this.baseUrl}api/data/person/${auditor.item.personId}`).pipe(map((response) => { return response.item })) : of(null)
          , this._httpClient.get<PageResponse<AuditorLoginAccessView>>(`${this.baseUrl}api/data/auditor-login-access-view`, { params: { 'find[AuditorId]': auditorId } }).pipe(map((response) => { return response.items }))
          , this._httpClient.get<PageResponse<UserNote>>(`${this.baseUrl}api/data/user-notes-view?itemsPerPage=1000&find[SubjectId]=${auditorId.toString()}&find[SubjectType]=${'Auditor'}`).pipe(map((response) => { return response.items }))
        ]

        return forkJoin(tasks).pipe(
          map(([person, loginAccess, notes]: [Person, AuditorLoginAccessView, any]) => {
            return {
              auditor: auditor.item,
              person: person,
              notes: notes,
              loginAccess: loginAccess[0]
            } as AuditorDetailsView;
          })
        )
      })
    );
  }

  saveAuditorScorecard(id: any, payload: any, patch: boolean = false) {
    if (id) {
        if (patch) {
            return this._httpClient.patch<PageResponse<AuditorPerformanceScorecard>>(`${this.baseUrl}api/data/admin/auditor-performance-scorecard/${id}`, payload);
        } else {
            return this._httpClient.put<PageResponse<AuditorPerformanceScorecard>>(`${this.baseUrl}api/data/admin/auditor-performance-scorecard/${id}`, payload);
        }
    } else {
      return this._httpClient.post<PageResponse<AuditorPerformanceScorecard>>(`${this.baseUrl}api/data/admin/auditor-performance-scorecard`, payload);
    }
  }
  deleteAuditorScorecard(id: any) {
    return this._httpClient.delete(`${this.baseUrl}api/data/admin/auditor-performance-scorecard/${id}`);
  }

  saveAuditorScorecardLineItem(id: any, payload: any, patch: boolean = false) {
    if (id) {
        if (patch) {
          return this._httpClient.patch<PageResponse<AuditorPerformanceLineItem>>(`${this.baseUrl}api/data/admin/auditor-performance-line-item/${id}`, payload);
        }
      return this._httpClient.put<PageResponse<AuditorPerformanceLineItem>>(`${this.baseUrl}api/data/admin/auditor-performance-line-item/${id}`, payload);
    }
    return this._httpClient.post<PageResponse<AuditorPerformanceLineItem>>(`${this.baseUrl}api/data/admin/auditor-performance-line-item`, payload);
  }

  getAuditorScorecardDetails(id, auditorId): Observable<AuditorPerformanceScorecardDetailsView> {
    return this._httpClient.get<PageResponse<Auditor>>(`${this.baseUrl}api/data/auditor/${auditorId}`).pipe(
      switchMap((auditor: PageResponse<Auditor>) => {
        const tasks = [
          (auditor?.item?.personId > 0) ? this._httpClient.get<PageResponse<Person>>(`${this.baseUrl}api/data/person/${auditor.item.personId}`).pipe(map((response) => { return response.item })) : of(null)
          , this.getAuditorPerformanceScorecardRecords({ auditorPerformanceScorecardId: id, auditorId: auditorId, currentPage: 1, itemsPerPage: 1, sort: 'created', sortDir: 'desc' } as any)
          , this.getAuditorPerformanceScorecardById(id)
          , this.getAuditorPerformanceScorecardCriteria({ currentPage: 1, itemsPerPage: 50, sort: 'SortOrder', sortDir: 'asc' } as any)
          , this.getAuditorPerformanceScorecardLineItems({ auditorPerformanceScorecardId: id, currentPage: 1, itemsPerPage: 50, sort: 'created', sortDir: 'desc' } as any)
        ];

        return forkJoin(tasks).pipe(
          map(([person, scorecardView, scorecard, criteria, lineItems]: [Person, any, any, any, any]) => {
            return {
                auditorId: auditorId,
                auditorName: `${person?.firstName} ${person?.lastName}`,
                auditor: auditor.item,
                auditorPerformanceScorecard: scorecard,
                auditorPerformanceScorecardView: scorecardView?.items?.[0] || null,
                auditorPerformanceCriteria: criteria?.items || [],
                auditorPerformanceLineItems: lineItems?.items || [],
            } as AuditorPerformanceScorecardDetailsView;
          })
        )
      })
    );
  }

  getAuditors(request: any, isExport: boolean): Observable<any> {
    let params = {};
    params = this.getParams(request, params);
    if (isExport) {
      return this._httpClient.get(`${this.baseUrl}api/data/auditors-view/export`, { params: params, responseType: 'text' });
    } else {
      return this._httpClient.get<any>(`${this.baseUrl}api/data/auditors-view`, { params: params }).pipe(
        map((auditors: any) => {
          const response: PageResponse<AuditorsView> = new PageResponse<AuditorsView>();
          response.items = auditors.items;
          response.totalItems = auditors.page.totalItems;
          response.currentPage = request.currentPage;
          response.itemsPerPage = request.itemsPerPage;
          response.query = null;
          response.page = auditors.page;
          return response;
        })
      );
    }

  }

  getAuditorCompetencies(request: PageRequest): Observable<PageResponse<AuditorCompetencyView>> {
    let params = {};
    params = this.getParams(request, params);
    if (request.sort && request.sortDir) {
      if (Object.keys(this.sortCompetencyMap).indexOf(request.sort) > -1) {
        params[`sort[${this.sortCompetencyMap[request.sort]}]`] = request.sortDir;
      }
      else {
        params[`sort[${request.sort}]`] = request.sortDir;
      }
    }

    return this._httpClient.get<any>(`${this.baseUrl}api/data/auditor-competency-view`, { params: params })
      .pipe(map((competencies: any) => {
        const response: PageResponse<AuditorCompetencyView> = new PageResponse<AuditorCompetencyView>();
        response.items = competencies.items;
        response.totalItems = competencies.page.totalItems;
        response.currentPage = competencies.page.currentPage;
        response.itemsPerPage = competencies.page.itemsPerPage;
        response.query = null;
        return response;
      })
      );
  }

  getAuditorStandards(request: PageRequest): Observable<PageResponse<AuditorStandard>> {
    let params = {};
    params = this.getParams(request, params);
    if (request.sort && request.sortDir) {
      if (Object.keys(this.sortCompetencyMap).indexOf(request.sort) > -1) {
        params[`sort[${this.sortCompetencyMap[request.sort]}]`] = request.sortDir;
      }
      else {
        params[`sort[${request.sort}]`] = request.sortDir;
      }
    }

    return this._httpClient.get<any>(`${this.baseUrl}api/data/auditor-standard`, { params: params })
      .pipe(map((competencies: any) => {
        const response: PageResponse<AuditorStandard> = new PageResponse<AuditorStandard>();
        response.items = competencies.items;
        response.totalItems = competencies.page.totalItems;
        response.currentPage = competencies.page.currentPage;
        response.itemsPerPage = competencies.page.itemsPerPage;
        response.query = null;
        return response;
      })
      );
  }

  getAuditorUnavaibility(request: any): Observable<PageResponse<AuditorUnavaibilityView>> {
    let params = {};
    params = this.getParams(request, params);

    return this._httpClient.get<any>(`${this.baseUrl}api/data/auditor-unavailability-view`, { params: params })
      .pipe(map((res: any) => {
        const response: PageResponse<AuditorUnavaibilityView> = new PageResponse<AuditorUnavaibilityView>();
        response.items = res.items;
        response.totalItems = res.page.totalItems;
        response.currentPage = res.page.currentPage;
        response.itemsPerPage = res.page.itemsPerPage;
        response.query = null;
        return response;
      })
      );
  }

  getAuditorIndustryCodeCompetencies(request: PageRequest, onlyLegacy: boolean = false): Observable<PageResponse<AuditorIndustryCodeCompetencyView>> {
    let params = {};
    params = this.getParams(request, params);
    params['find[deleted]'] = 'IS NULL';
    params['find[industryCodeId]'] = onlyLegacy ? 'IS NOT NULL' : 'IS NULL';
    if (request.sort && request.sortDir) {
      if (Object.keys(this.sortCompetencyIndustryCodeMap).indexOf(request.sort) > -1) {
        params[`sort[${this.sortCompetencyIndustryCodeMap[request.sort]}]`] = request.sortDir;
      }
      else {
        params[`sort[${request.sort}]`] = request.sortDir;
      }
    }

    return this._httpClient.get<any>(`${this.baseUrl}api/data/auditor-industry-competency-view`, { params: params })
      .pipe(map((competencies: any) => {
        const response: PageResponse<AuditorIndustryCodeCompetencyView> = new PageResponse<AuditorIndustryCodeCompetencyView>();
        response.items = competencies.items?.map((rows) => {
          return {
            standardName: rows.standardName
            , id: rows?._id
            , industryCodeId: rows?._id
            // , industryCodeName: rows.industryCodeName
            , reviewerName: rows.reviewerName
            , reviewed: rows.reviewed
            , modified: rows.modified
            , ...rows
          }
        });
        response.totalItems = competencies.page.totalItems;
        response.currentPage = competencies.page.currentPage;
        response.itemsPerPage = competencies.page.itemsPerPage;
        response.query = null;
        return response;
      })
      );
  }

  getIndustryCompetency(id: string): Observable<AuditorIndustryCompetency> {
    return this._httpClient.get<any>(`${this.baseUrl}api/data/admin/auditor-industry-competency/${id}`)
      .pipe(map((competency: any) => {
        return competency.item;
      })
    );
  }

  getIndustryCompetencySummary(id: string): Observable<PageResponse<AuditorCompetencySummary[]>> {
    return this._httpClient.get<any>(`${this.baseUrl}api/data/auditor-industry-competency-summary-view`, { params: { 'find[AuditorIndustryCompetencyId]': id } })
      .pipe(map((competency: any) => {
        return competency.items;
      })
      );
  }

  getCompetency(ID: number): Observable<PageResponse<AuditorCompetency>> {
    return this._httpClient.get<any>(`${this.baseUrl}api/data/auditor-competency/${ID}`)
      .pipe(map((competency: any) => {
        const ret = new PageResponse<AuditorCompetency>();
        ret.item = competency.item;
        return ret;
      })
      );
  }

  removeCompetency(ID: number): Observable<any> {
    return this._httpClient.delete(`${this.baseUrl}api/data/auditor-competency/${ID}`);
  }

  getStandard(id: number): Observable<PageResponse<AuditorStandard>> {
    return this._httpClient.get<any>(`${this.baseUrl}api/data/auditor-standard/${id}`)
      .pipe(map((competency: any) => {
        const ret = new PageResponse<AuditorStandard>();
        ret.item = competency.item;
        return ret;
      })
      );
  }

  removeStandard(id: number): Observable<any> {
    return this._httpClient.delete(`${this.baseUrl}api/data/auditor-standard/${id}`);
  }

  getAuditorTrainingRecords(request: PageRequest): Observable<PageResponse<AuditorRecordTrainingView>> {
    let params = {};
    params = this.getParams(request, params);

    if (request.sort && request.sortDir) {
      if (Object.keys(this.sortTrainingRecordMap).indexOf(request.sort) > -1) {
        params[`sort[${this.sortTrainingRecordMap[request.sort]}]`] = request.sortDir;
      }
      else {
        params[`sort[${request.sort}]`] = request.sortDir;
      }
    }

    return this._httpClient.get<any>(`${this.baseUrl}api/data/auditor-record-training-view`, { params: params })
      .pipe(map((trainingRecords: any) => {
        const response: PageResponse<AuditorRecordTrainingView> = new PageResponse<AuditorRecordTrainingView>();
        response.items = trainingRecords.items;
        response.totalItems = trainingRecords.page.totalItems;
        response.currentPage = trainingRecords.page.currentPage;
        response.itemsPerPage = trainingRecords.page.itemsPerPage;
        response.query = null;
        return response;
      })
      );
  }

  getAuditorCompetencyRecords(request: PageRequest): Observable<PageResponse<AuditorRecordCompetencyView>> {
    let params = {};
    params = this.getParams(request, params);

    if (request.sort && request.sortDir) {
      if (Object.keys(this.sortCompetencyRecordMap).indexOf(request.sort) > -1) {
        params[`sort[${this.sortCompetencyRecordMap[request.sort]}]`] = request.sortDir;
      }
      else {
        params[`sort[${request.sort}]`] = request.sortDir;
      }
    }

    return this._httpClient.get<any>(`${this.baseUrl}api/data/auditor-record-competency-view`, { params: params })
      .pipe(map((competencyRecords: any) => {
        const response: PageResponse<AuditorRecordCompetencyView> = new PageResponse<AuditorRecordCompetencyView>();
        response.items = competencyRecords.items;
        response.totalItems = competencyRecords.page.totalItems;
        response.currentPage = competencyRecords.page.currentPage;
        response.itemsPerPage = competencyRecords.page.itemsPerPage;
        response.query = null;
        return response;
      })
      );
  }

  getAuditorEvaluationRecords(request: PageRequest): Observable<PageResponse<AuditorRecordEvaluationView>> {
    let params = {};
    params = this.getParams(request, params);

    if (request.sort && request.sortDir) {
      if (Object.keys(this.sortEvaluationRecordMap).indexOf(request.sort) > -1) {
        params[`sort[${this.sortEvaluationRecordMap[request.sort]}]`] = request.sortDir;
      }
      else {
        params[`sort[${request.sort}]`] = request.sortDir;
      }
    }

    return this._httpClient.get<any>(`${this.baseUrl}api/data/auditor-record-evaluation-view`, { params: params })
      .pipe(map((evaluationRecords: any) => {
        const response: PageResponse<AuditorRecordEvaluationView> = new PageResponse<AuditorRecordEvaluationView>();
        response.items = evaluationRecords.items;
        response.totalItems = evaluationRecords.page.totalItems;
        response.currentPage = evaluationRecords.page.currentPage;
        response.itemsPerPage = evaluationRecords.page.itemsPerPage;
        response.query = null;
        return response;
      })
      );
  }

  getAuditorMiscellaneousRecords(request: PageRequest): Observable<PageResponse<AuditorRecordMiscellaneousView>> {
    let params = {};
    params = this.getParams(request, params);

    if (request.sort && request.sortDir) {
      if (Object.keys(this.sortMiscellaneousRecordMap).indexOf(request.sort) > -1) {
        params[`sort[${this.sortMiscellaneousRecordMap[request.sort]}]`] = request.sortDir;
      }
      else {
        params[`sort[${request.sort}]`] = request.sortDir;
      }
    }

    return this._httpClient.get<any>(`${this.baseUrl}api/data/auditor-record-miscellaneous-view`, { params: params })
      .pipe(map((miscellaneousRecords: any) => {
        const response: PageResponse<AuditorRecordMiscellaneousView> = new PageResponse<AuditorRecordMiscellaneousView>();
        response.items = miscellaneousRecords.items;
        response.totalItems = miscellaneousRecords.page.totalItems;
        response.currentPage = miscellaneousRecords.page.currentPage;
        response.itemsPerPage = miscellaneousRecords.page.itemsPerPage;
        response.query = null;
        return response;
      })
      );
  }

  getAuditorPerformanceRecords(request: PageRequest): Observable<PageResponse<AuditorRecordPerformanceView>> {
    let params = {};
    params = this.getParams(request, params);

    if (request.sort && request.sortDir) {
      if (Object.keys(this.sortPerformanceRecordMap).indexOf(request.sort) > -1) {
        params[`sort[${this.sortPerformanceRecordMap[request.sort]}]`] = request.sortDir;
      }
      else {
        params[`sort[${request.sort}]`] = request.sortDir;
      }
    }

    return this._httpClient.get<any>(`${this.baseUrl}api/data/auditor-record-performance-view`, { params: params })
      .pipe(map((performanceRecords: any) => {
        const response: PageResponse<AuditorRecordPerformanceView> = new PageResponse<AuditorRecordPerformanceView>();
        response.items = performanceRecords.items;
        response.totalItems = performanceRecords.page.totalItems;
        response.currentPage = performanceRecords.page.currentPage;
        response.itemsPerPage = performanceRecords.page.itemsPerPage;
        response.query = null;
        return response;
      })
      );
  }

  getAuditorPerformanceScorecardRecords(request: any): Observable<PageResponse<AuditorPerformanceScorecardView>> {
    let params = {};
    params = this.getParams(request, params);

    if (request.sort && request.sortDir) {
      if (Object.keys(this.sortPerformanceRecordMap).indexOf(request.sort) > -1) {
        params[`sort[${this.sortPerformanceRecordMap[request.sort]}]`] = request.sortDir;
      }
      else {
        params[`sort[${request.sort}]`] = request.sortDir;
      }
    }

    return this._httpClient.get<any>(`${this.baseUrl}api/data/admin/auditor-performance-scorecard-view`, { params: params })
      .pipe(map((performanceRecords: any) => {
        const response: PageResponse<AuditorPerformanceScorecardView> = new PageResponse<AuditorPerformanceScorecardView>();
        response.items = performanceRecords.items;
        response.totalItems = performanceRecords.page.totalItems;
        response.currentPage = performanceRecords.page.currentPage;
        response.itemsPerPage = performanceRecords.page.itemsPerPage;
        response.query = null;
        return response;
      })
      );
  }
  getAuditorPerformanceScorecardCriteria(request: any): Observable<PageResponse<AuditorPerformanceCriterium>> {
    let params = {};
    params = this.getParams(request, params);
    params['find[deleted]'] = "IS NULL";

    if (request.sort && request.sortDir) {
      if (Object.keys(this.sortPerformanceRecordMap).indexOf(request.sort) > -1) {
        params[`sort[${this.sortPerformanceRecordMap[request.sort]}]`] = request.sortDir;
      }
      else {
        params[`sort[${request.sort}]`] = request.sortDir;
      }
    }

    return this._httpClient.get<any>(`${this.baseUrl}api/data/admin/auditor-performance-criteria`, { params: params })
      .pipe(map((performanceRecords: any) => {
        const response: PageResponse<AuditorPerformanceCriterium> = new PageResponse<AuditorPerformanceCriterium>();
        response.items = performanceRecords.items;
        response.totalItems = performanceRecords.page.totalItems;
        response.currentPage = performanceRecords.page.currentPage;
        response.itemsPerPage = performanceRecords.page.itemsPerPage;
        response.query = null;
        return response;
      })
      );
  }
  getAuditorPerformanceScorecardLineItems(request: any): Observable<PageResponse<AuditorPerformanceLineItem>> {
    let params = {};
    params = this.getParams(request, params);

    if (request.sort && request.sortDir) {
      if (Object.keys(this.sortPerformanceRecordMap).indexOf(request.sort) > -1) {
        params[`sort[${this.sortPerformanceRecordMap[request.sort]}]`] = request.sortDir;
      }
      else {
        params[`sort[${request.sort}]`] = request.sortDir;
      }
    }

    return this._httpClient.get<any>(`${this.baseUrl}api/data/admin/auditor-performance-line-item`, { params: params })
      .pipe(map((performanceRecords: any) => {
        const response: PageResponse<AuditorPerformanceLineItem> = new PageResponse<AuditorPerformanceLineItem>();
        response.items = performanceRecords.items;
        response.totalItems = performanceRecords.page.totalItems;
        response.currentPage = performanceRecords.page.currentPage;
        response.itemsPerPage = performanceRecords.page.itemsPerPage;
        response.query = null;
        return response;
      })
      );
  }

  getAuditorPerformanceScorecardById(id): Observable<AuditorPerformanceScorecardView> {
    return this._httpClient.get<any>(`${this.baseUrl}api/data/admin/auditor-performance-scorecard/${id}`)
      .pipe(map((performanceRecords: any) => {
        return performanceRecords?.item;
      })
      );
  }

  getAuditorWitnessRecords(request: PageRequest): Observable<PageResponse<AuditorRecordWitnessView>> {
    let params = {};
    params = this.getParams(request, params);

    if (request.sort && request.sortDir) {
      if (Object.keys(this.sortWitnessRecordMap).indexOf(request.sort) > -1) {
        params[`sort[${this.sortWitnessRecordMap[request.sort]}]`] = request.sortDir;
      }
      else {
        params[`sort[${request.sort}]`] = request.sortDir;
      }
    }

    return this._httpClient.get<any>(`${this.baseUrl}api/data/auditor-record-witness-view`, { params: params })
      .pipe(map((witnessRecords: any) => {
        const response: PageResponse<AuditorRecordWitnessView> = new PageResponse<AuditorRecordWitnessView>();
        response.items = witnessRecords.items;
        response.totalItems = witnessRecords.page.totalItems;
        response.currentPage = witnessRecords.page.currentPage;
        response.itemsPerPage = witnessRecords.page.itemsPerPage;
        response.query = null;
        return response;
      })
      );
  }

  getRecord(ID: number): Observable<PageResponse<AuditorRecord>> {
    return this._httpClient.get<any>(`${this.baseUrl}api/data/auditor-record/${ID}`)
      .pipe(map((competency: any) => {
        const ret = new PageResponse<AuditorRecord>();
        ret.item = competency.item;
        return ret;
      })
      );
  }

  removeRecord(ID: number): Observable<any> {
    return this._httpClient.delete(`${this.baseUrl}api/data/auditor-record/${ID}`);
  }

  searchNames(query: string): Observable<string[]> {
    const params = {
      'orLike[LastName]': query,
      'orLike[FirstName]': query,
      'itemsPerPage': 100
    };

    return this._httpClient.get<any>(`${this.baseUrl}api/data/auditors-view`, { params: params })
      .pipe(
        map((auditors: any) => {
          return auditors.items;
        })
      );
  }

  removeAuditor(auditorId: number): Observable<any> {
    return this._httpClient.delete(`${this.baseUrl}api/data/auditor/${auditorId}`);
  }

  getCompetenciesForm(standardId): any {
    return this._httpClient.get<PageResponse<any>>(`${this.baseUrl}api/data/industry-competency/${standardId}/form`).pipe(
      map((response) => {
        return response.item;
      })
    );
  }

  deleteIndustryCodeCompetency(id): any {
    return this._httpClient.delete(`${this.baseUrl}api/data/admin/auditor-industry-competency/${id}`);
  }

  getAuditorStandardRate(auditorId: number, standardId: number): Observable<AuditorStandardRate> {
    const params = {};
    if (auditorId) {
        params['find[auditorId]'] = auditorId;
    }
    if (standardId) {
        params['find[standardId]'] = standardId;
    }

    return this._httpClient.get<PageResponse<AuditorStandardRate>>(`${this.baseUrl}api/data/admin/auditor-standard-rate`, { params: params }).pipe(
      map((response) => {
        return response?.items?.length > 0 ? response.items[0] : null
      })
    );
  }

  getAuditorStandardRateForAuditor(auditorId: number, standardId: number): Observable<AuditorStandardRate> {
    if (auditorId == null || standardId == null) {
      return of(null);
    }
    const params = {};
    params['find[auditorId]'] = auditorId;
    params['find[standardId]'] = standardId;
    return this._httpClient.get<PageResponse<AuditorStandardRate>>(`${this.baseUrl}api/data/auditor/auditor-standard-rate`, { params: params }).pipe(
      map((response) => {
        return response?.items?.length > 0 ? response.items[0] : null
      })
    );
  }

  getAuditorStandardRates(request: PageRequest): Observable<PageResponse<AuditorsToStandardView>> {
    let params = {};
    params = this.getParams(request, params);

    return this._httpClient.get<PageResponse<AuditorsToStandardView>>(`${this.baseUrl}api/data/auditors-to-standard-view`, { params: params }).pipe(
      map((response) => {
        return response;
      })
    );
  }

  exportAuditorWiseAverageLateReport(auditorId: string): Observable<any> {
        const params = {};
        params['fileType'] = 'xlsx';
        params['find[auditorId]'] = auditorId;

        return this._httpClient.get(`${this.baseUrl}api/data/admin/view/auditor/average-report-due/export`, { params: params, responseType: 'arraybuffer' })
  }
}
